import { Plus } from "lucide-react";
import { Button, type ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useJobMode } from "@/components/jobs/jobModeStore";

interface PostJobButtonProps {
  /** Button label. Defaults to "Post a Job". */
  label?: string;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
  className?: string;
  /** Stretch to full width (handy in sidebars / empty states). */
  fullWidth?: boolean;
  /** Render the leading + icon. Defaults to true. */
  showIcon?: boolean;
  /** Forwarded to the chooser as ?agent= (e.g. from a "Hire Agent" CTA). */
  agentId?: string;
  /** Optional custom icon node (overrides the default Plus). */
  icon?: React.ReactNode;
}

/**
 * Drop-in CTA that opens the Mode Chooser dialog. Must be rendered inside a
 * <JobModeProvider>. The provider owns the single shared <JobModeDialog>.
 */
export function PostJobButton({
  label = "Post a Job",
  variant = "default",
  size = "default",
  className,
  fullWidth = false,
  showIcon = true,
  agentId,
  icon,
}: PostJobButtonProps) {
  const { openChooser } = useJobMode();

  return (
    <Button
      variant={variant}
      size={size}
      className={cn(fullWidth && "w-full", className)}
      onClick={() => openChooser(agentId)}
    >
      {showIcon && (icon ?? <Plus />)}
      {label}
    </Button>
  );
}
